

import GxApplyButton from "../../components/common/actions/buttons/GxApplyButton";

interface DrawerSingleFooterProps {
  handleClose: () => void;
  handledrawerSubmit: () => void;
  submit?: string;
  loading?: boolean;
  disabled?: boolean;
}

const DrawerSingleFooter: React.FC<DrawerSingleFooterProps> = ({
  handledrawerSubmit,
  submit,
  loading,
  disabled,
}) => (
  <div className="gx-drawer-footer">
    <div className="gx-drawer-row">
      {submit && (
        <GxApplyButton 
          label={submit} 
          handledrawerSubmit={handledrawerSubmit} 
          loading={loading}
          disabled={disabled}
        />
      )}
    </div>
  </div>
);

export default DrawerSingleFooter;